<div class="white-box d-flex flex-column gap-2">
</div>
<div>
	<readonly-access [readonly]="!dialogDataService.canRecruitVolunteers()"></readonly-access>

	<div class="d-flex flex-column mb-4">
		<h6>Score</h6>
		<p>{{scoreText()}}</p>
	</div>
	<div class="row ">
		<div class="col-md-6">
			<div class="d-flex flex-column gap-4">
				<div>
					@if(dialogDataService.volunteerDetails()){
					<lead-volunteer-date-time-form></lead-volunteer-date-time-form>
					}
				</div>
				<div class="d-flex flex-column mt-4">
					<h6>Mission Alignment</h6>
					<p>What excites you about volunteering with EforAll/EparaTodos?</p>
					<common-select-field [field]="missionAlignment()"></common-select-field>
				</div>
				<div class="d-flex flex-column">
					<h6>Expertise & Experience</h6>
					<p>Tell me a little bit about your expertise in your industry or field.</p>
					<common-select-field [field]="expertiseAndExperience()"></common-select-field>
				</div>
				<div class="d-flex flex-column">
					<h6>Schedule Flexibility</h6>
					<common-select-field [field]="scheduleFlexibility()"></common-select-field>
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="d-flex flex-column gap-4">
				<div class="d-flex flex-column">
					<h6>Mentorship Style & Self-Perception</h6>
					<p>Here are a few mentorship styles. Which do you feel best describes your style? (Check all that
						apply)
					</p>
					<ul>
						<li>Advisory: I will listen, advise and help entrepreneurs think through options.</li>
						<li>Structured: I prefer the entrepreneur to provide an agenda for every meeting.</li>
						<li>Hands On: I will help entrepreneurs with specific tasks</li>
						<li>Flexible: I prefer a free-flowing discussion of ideas and will adapt to any format.</li>
						<li>Goal Oriented: I will help the entrepreneur tackle each aspect of the curriculum and achieve
							milestones.</li>
						<li>Supportive: I like to inspire and motivate alongside professional guidance.</li>
						<li>Resource Connector: My connections to other resources, networks, or individuals within my
							sphere
							in my superpower.</li>
					</ul>
					<common-select-field [field]="mentorshipStyle()"></common-select-field>
				</div>
				<div class="d-flex flex-column">
					<h6>Presentation Style & Self Perception</h6>
					<common-select-field [field]="presentationStyle()"></common-select-field>
				</div>
				<div>
					<common-text-field [field]="notes()"></common-text-field>
				</div>
				@if(volunteerInterview(); as volunteerInterview){
				<div class="d-flex flex-column mt-3">
					<p>Updated By: {{volunteerInterview.updatedByStaffName}} on
						{{getDate(volunteerInterview.updatedUTC)}}</p>
				</div>
				}
			</div>
		</div>
	</div>
	@if(isEnabledInterviewForm()) {
	<div class="mt-3">
		<common-button-row [center]="true">
			@if(volunteerInterview()) {
			<button [disabled]="!hasSubmitButton()" #interviewForm class="btn btn-standard">
				Update Interview
			</button>
			<button [disabled]="!hasSubmitButton()" (click)="resetForm()" class="btn btn-standard">
				Revert Changes
			</button>
			} @else {
			<button #interviewForm class="btn btn-standard">
				Save Interview
			</button>
			}

		</common-button-row>
	</div>
	}
</div>